module.exports = __webpack_public_path__ + "static/img/15002842221.27379e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15002842221.jpg
// module id = sYx7
// module chunks = 0